/* @ngInject */

export default ($filter, $timeout, LIST) => {
  var model = angular.copy(LIST);
  var service = {
    model: model,
    clear: clear,
    deselectedData: deselectedData,
    getCount: getCount,
    getData: getData,
    getGroupingByFirstLetter: getGroupingByFirstLetter,
    getGroupingByFirstLetters: getGroupingByFirstLetters,
    getOrder: getOrder,
    getOrderBy: getOrderBy,
    getOrderClass: getOrderClass,
    getRecordsShown: getRecordsShown,
    getSelected: getSelected,
    getSelectedCount: getSelectedCount,
    initGroupingByFirstLetter: initGroupingByFirstLetter,
    incRecordsShown: incRecordsShown,
    isGroupingByFirstLetter: isGroupingByFirstLetter,
    isRecordsShownAll: isRecordsShownAll,
    isSelectedAny: isSelectedAny,
    isSelectedAll: isSelectedAll,
    removeData: removeData,
    setData: setData,
    setDataAppend: setDataAppend,
    setDataReplace: setDataReplace,
    setGroupingByFirstLetter: setGroupingByFirstLetter,
    setOrderBy: setOrderBy,
    setSelected: setSelected
  };
  return service;

  /**
   * Clear list service.
   */
  function clear() {
    model = angular.copy(LIST);
  }

  /**
   * Deselected item(s).
   *
   * @param {Object|Object[]} _object
   * @param {Boolean} [_value]
   *
   * @returns {Boolean}
   */
  function deselectedData(_object) {
    var len = _object.length;
    while (len--) {
      _object[len].isSelected = false;
    }
    return _object.isSelected;
  }

  /**
   * Get data count.
   *
   * @returns {Number}
   */
  function getCount() {
    return model.data.length;
  }

  /**
   * Get data.
   *
   * @returns {Object[]}
   */
  function getData() {
    return model.data;
  }

  /**
   * Get set first letter grouping.
   *
   * @returns {String} - Grouping.
   */
  function getGroupingByFirstLetter() {
    return model.grouping.startingLetter;
  }

  /**
   * Get first letter available groupings.
   *
   * @returns {Array} - Groupings.
   */
  function getGroupingByFirstLetters() {
    return model.grouping.startingLetters;
  }

  /**
   * Get order direction of the list.
   *
   * @returns {Boolean} - Order direction.
   */
  function getOrder() {
    return model.ordering.isReversed;
  }

  /**
   * Get order property of the list.
   *
   * @returns {String} - Property name.
   */
  function getOrderBy() {
    return model.ordering.property;
  }

  /**
   * Get order class for the list. Class is generated based on the direction and property.
   *
   * @param {String} _property - Name of the property.
   *
   * @returns {String} - Class.
   */
  function getOrderClass(_property) {
    var output = model.ordering.isReversed ? 'reversed' : '';
    output += model.ordering.property === _property ? ' active' : '';
    return output;
  }

  /**
   * Get shown limit of records in the list.
   *
   * @returns {Number} - Number of items.
   */
  function getRecordsShown() {
    return model.records.shown;
  }

  /**
   * Get selected records.
   *
   * @returns {Object[]}
   */
  function getSelected() {
    return $filter('filter')(model.data, { isSelected: true });
  }

  /**
   * Get number of selected records.
   *
   * @returns {Number}
   */
  function getSelectedCount() {
    return getSelected().length;
  }

  /**
   * Initialize grouping by the first letter.
   *
   * @param {Object[]} _collection
   */
  function initGroupingByFirstLetter(_collection) {
    model.grouping.startingLetters = Object.keys(
      _.groupBy(_collection, function (item) {
        return item?.getName()?.charAt(0)?.toUpperCase();
      })
    ).sort();
    model.grouping.startingLetters.unshift('ALL');
  }

  /**
   * Set list records limit.
   */
  function incRecordsShown() {
    model.records.shown += model.records.limit;
  }

  /**
   * Is list grouped by given first letter?
   *
   * @param {String} _letter - Letter.
   *
   * @returns {Boolean}
   */
  function isGroupingByFirstLetter(_letter) {
    return model.grouping.startingLetter === _letter;
  }

  /**
   * Is collection showing all records?
   *
   * @returns {Boolean}
   */
  function isRecordsShownAll() {
    if (!model || !model.data || !model.data.length) {
      return true;
    }
    return model.data.length <= model.records.shown;
  }

  /**
   * Is anything in list selected?
   *
   * @returns {Boolean}
   */
  function isSelectedAny() {
    return _.some(model.data, function (item) {
      return item.isSelected === true;
    });
  }

  /**
   * Is everything in list selected?
   *
   * @returns {Boolean}
   */
  function isSelectedAll() {
    return _.every(model.data, function (item) {
      return item.isSelected === true;
    });
  }

  /**
   * Remove data.
   *
   * @param {Object|Object[]} _object - Object to remove from collection.
   */
  function removeData(_object) {
    if (_object instanceof Array) {
      var len = _object.length;
      while (len--) {
        removeData(_object[len]);
      }
    } else {
      model.data.splice(model.data.indexOf(_object), 1);
    }
  }

  /**
   * Set data.
   *
   * @param {Object[]} _collection
   */
  function setData(_collection) {
    model.records.shown = model.records.limit;
    model.data = _collection;
  }

  /**
   * Append data.
   *
   * @param {Object|Object[]} _object
   */
  function setDataAppend(_object) {
    if (_object instanceof Array) {
      model.data = model.data.concat(_object);
    } else {
      model.data.push(_object);
    }
  }

  /**
   * Replace data.
   *
   * @param {Object} _object
   * @param {String} _key
   */
  function setDataReplace(_object, _key) {
    var key = _key || 'id';
    var index = _.findIndex(model.data, function (obj) {
      return obj[key] === _object[key];
    });
    $timeout(function () {
      model.data.splice(index, 1);
      $timeout(function () {
        model.data.push(_object);
      });
    });
  }

  /**
   * Set grouping first letter.
   *
   * @param {String} _letter - Letter.
   */
  function setGroupingByFirstLetter(_letter) {
    model.grouping.startingLetter = _letter;
  }

  /**
   * Set order by property.
   *
   * @param {String} _property
   */
  function setOrderBy(_property) {
    if (model.ordering.property === _property) {
      model.ordering.isReversed = !model.ordering.isReversed;
    } else {
      model.ordering.property = _property;
      model.ordering.isReversed = false;
    }
  }

  /**
   * Set selected item(s).
   *
   * @param {Object|Object[]} _object
   * @param {Boolean} [_value]
   *
   * @returns {Boolean}
   */
  function setSelected(_object, _value) {
    if (_object instanceof Array) {
      var len = _object.length;
      var val = !isSelectedAny();
      while (len--) {
        setSelected(_object[len], val);
      }
      return val;
    } else {
      _object.isSelected =
        _value !== undefined ? _value : !_object.isSelected ? true : !_object.isSelected;
      return _object.isSelected;
    }
  }

  /**
   * Display number of selected item.
   *
   * @param {Object} _params
   * @param {Array} _params.items
   */
  function numberOfSelected(_params) {
    return $filter('filter')(_params.items, { isSelected: true }).length;
  }
};
